<div class="mb-5">
    <app-header *ngIf="router.url.indexOf(paymentComponentUrl) == -1"></app-header>
</div>
<router-outlet></router-outlet>
